import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SuiteHome.css';

function SuiteHome() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Welcome - Wixon & Cross Desk Suite';
  }, []);

  return (
    <div className="suite-home">
      {/* Hero Section */}
      <header className="suite-hero">
        <nav className="suite-nav">
          <div className="suite-logo">
            <h1>Wixon & Cross</h1>
            <span className="suite-tagline">Desk Suite</span>
          </div>
          <div className="suite-nav-actions">
            <button className="btn-link" onClick={() => navigate('/signin')}>
              Sign In
            </button>
            <button className="btn-primary-hero" onClick={() => navigate('/account-requests')}>
              Request Access
            </button>
          </div>
        </nav>

        <div className="hero-content">
          <h2 className="hero-title">
            Your Complete Software Development Suite
          </h2>
          <p className="hero-subtitle">
            Manage projects, track defects, handle feature requests, maintain customer relationships, 
            and streamline invoicing—all in one integrated platform.
          </p>
          <div className="hero-cta">
            <button className="btn-hero-primary" onClick={() => navigate('/account-requests')}>
              Request Access
            </button>
            <button className="btn-hero-secondary" onClick={() => navigate('/signin')}>
              Sign In
            </button>
          </div>
        </div>
      </header>

      {/* Features Section */}
      <section className="suite-features">
        <div className="features-container">
          <h3 className="section-title">Everything You Need to Build Better Software</h3>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📋</div>
              <h4>Project Management</h4>
              <p>Plan sprints, assign tasks, and track progress across your entire team.</p>
              <span className="feature-status">Coming Soon</span>
            </div>

            <div className="feature-card feature-card-active">
              <div className="feature-icon">🐛</div>
              <h4>Defect Tracker</h4>
              <p>Log, prioritize, and resolve bugs with full team collaboration and notifications.</p>
              <span className="feature-status feature-status-active">Active</span>
            </div>

            <div className="feature-card feature-card-active">
              <div className="feature-icon">✨</div>
              <h4>Feature Requests</h4>
              <p>Request and vote on new features with community-driven prioritization.</p>
              <span className="feature-status feature-status-active">Active</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📝</div>
              <h4>Notes</h4>
              <p>Quick notes and documentation for your team to stay organized.</p>
              <span className="feature-status">Coming Soon</span>
            </div>

            <div className="feature-card feature-card-active">
              <div className="feature-icon">🚨</div>
              <h4>Incident Reports</h4>
              <p>Report and track incidents with automatic cross-app triggers for injuries, SOP violations, and maintenance.</p>
              <span className="feature-status feature-status-active">Active</span>
            </div>

            <div className="feature-card feature-card-active">
              <div className="feature-icon">🩹</div>
              <h4>Injury Reporting</h4>
              <p>Document workplace injuries with severity tracking, body part details, and treatment records.</p>
              <span className="feature-status feature-status-active">Active</span>
            </div>

            <div className="feature-card feature-card-active">
              <div className="feature-icon">📋</div>
              <h4>SOP System</h4>
              <p>Author Standard Operating Procedures with version control, plus log violations and deviations.</p>
              <span className="feature-status feature-status-active">Active</span>
            </div>

            <div className="feature-card feature-card-active">
              <div className="feature-icon">🔧</div>
              <h4>Maintenance Requests</h4>
              <p>Submit and track maintenance work orders with priority, assignee, and equipment tracking.</p>
              <span className="feature-status feature-status-active">Active</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h4>CRM</h4>
              <p>Manage customer relationships, track interactions, and grow your business.</p>
              <span className="feature-status">Coming Soon</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h4>Invoicing</h4>
              <p>Create professional invoices, track payments, and manage billing effortlessly.</p>
              <span className="feature-status">Coming Soon</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h4>Reporting</h4>
              <p>Generate insights with customizable reports across all your projects and apps.</p>
              <span className="feature-status">Coming Soon</span>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="suite-benefits">
        <div className="benefits-container">
          <h3 className="section-title">Why Wixon & Cross Desk Suite?</h3>
          
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">🔗</div>
              <h4>Single Sign-On</h4>
              <p>One account for all your tools. Sign in once and access everything.</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">🎯</div>
              <h4>Role-Based Access</h4>
              <p>Control what each team member can see and do with granular permissions.</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">🔔</div>
              <h4>Real-Time Notifications</h4>
              <p>Stay informed with instant updates on changes that matter to you.</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">📱</div>
              <h4>Responsive Design</h4>
              <p>Work seamlessly on desktop, tablet, or mobile—anywhere, anytime.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="suite-cta">
        <div className="cta-container">
          <h3>Ready to Get Started?</h3>
          <p>Join teams already using Wixon & Cross Desk Suite to build better software.</p>
          <button className="btn-cta" onClick={() => navigate('/signup')}>
            Create Your Free Account
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="suite-footer">
        <p>&copy; 2026 Wixon & Cross LLC. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default SuiteHome;
